import { useMemo } from "react";

import { useLocaleContext } from "../i18n/locale-context";

export function useFormattedDate(
  date: string | Date | undefined | null,
  opts: Intl.DateTimeFormatOptions
) {
  const { locale } = useLocaleContext();

  const [language] = locale.split("-");

  const formattedDate = useMemo(
    () =>
      date
        ? new Intl.DateTimeFormat(language, { timeZone: "UTC", ...opts }).format(new Date(date))
        : "",
    [date, language, opts]
  );

  return formattedDate;
}
